/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
class AuthorizationService extends __BaseService {
  static readonly authorizationMigrateDatabasePath =
    "/api/Authorization/MigrateDatabase";
  static readonly authorizationIsAdminPath = "/api/Authorization/IsAdmin";
  static readonly authorizationIsValidLoginPath =
    "/api/Authorization/IsValidLogin";
  static readonly authorizationIsValidEmailPath =
    "/api/Authorization/IsValidEmail";
  static readonly authorizationAttemptEmailPath =
    "/api/Authorization/AttemptEmail";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }
  authorizationMigrateDatabaseResponse(): __Observable<
    __StrictHttpResponse<string>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Authorization/MigrateDatabase`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  authorizationMigrateDatabase(): __Observable<string> {
    return this.authorizationMigrateDatabaseResponse().pipe(
      __map((_r) => _r.body as string)
    );
  }
  authorizationIsAdminResponse(): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Authorization/IsAdmin`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === "true",
        }) as __StrictHttpResponse<boolean>;
      })
    );
  }
  authorizationIsAdmin(): __Observable<boolean> {
    return this.authorizationIsAdminResponse().pipe(
      __map((_r) => _r.body as boolean)
    );
  }
  authorizationIsValidLoginResponse(): __Observable<
    __StrictHttpResponse<boolean>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Authorization/IsValidLogin`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === "true",
        }) as __StrictHttpResponse<boolean>;
      })
    );
  }
  authorizationIsValidLogin(): __Observable<boolean> {
    return this.authorizationIsValidLoginResponse().pipe(
      __map((_r) => _r.body as boolean)
    );
  }

  /**
   * @param emailAddress undefined
   */
  authorizationIsValidEmailResponse(
    emailAddress?: null | string
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (emailAddress != null)
      __params = __params.set("emailAddress", emailAddress.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Authorization/IsValidEmail`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === "true",
        }) as __StrictHttpResponse<boolean>;
      })
    );
  }
  /**
   * @param emailAddress undefined
   */
  authorizationIsValidEmail(
    emailAddress?: null | string
  ): __Observable<boolean> {
    return this.authorizationIsValidEmailResponse(emailAddress).pipe(
      __map((_r) => _r.body as boolean)
    );
  }
  authorizationAttemptEmailResponse(): __Observable<
    __StrictHttpResponse<string>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Authorization/AttemptEmail`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  authorizationAttemptEmail(): __Observable<string> {
    return this.authorizationAttemptEmailResponse().pipe(
      __map((_r) => _r.body as string)
    );
  }
}

module AuthorizationService {}

export { AuthorizationService };
